module.exports = __webpack_public_path__ + "static/media/award.49910be2.jpeg";